import { Component, ViewContainerRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Configuration, HttpClientCustom } from '../../shared';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { SharedData } from '../../shared/sharedData';
import { AddParentOrganizationComponent } from './addParentOrganization';

@Component({
    selector: 'child-orgs',
    templateUrl: 'childOrgs.html'
})
export class ChildOrgComponent {
    @Input()
    public childOrgs;
    @Output() public refresh = new EventEmitter();
    public _baseUrl: any;
    public showChild: boolean = false;
    public asl: boolean = false;
    public parentMatch: boolean = false;
    public orgData: any = [];
    
    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public share: SharedData,
        public modalService: NgbModal,
        public translate: TranslateService,
        vcr: ViewContainerRef
    ) {
        // this._toaster.setViewRef(vcr);
        this._baseUrl = _global.get('EPMS_BASE_URL');

    }

    public toggleChild() {
        let self = this;
        if (self.childOrgs) {
            self.showChild = !self.showChild;
        }
    }

    public addSubLevels(evn) {
        this.asl = evn;
    }

    public removeFromChild(id: number) {
        let self = this;
        let index;
        for (let i in self.childOrgs) {
            if (self.childOrgs[i].id === id) {
                index = i;
            }
        }
        self.childOrgs.splice(index, 1);
        self.translate.get('orgDeleted').subscribe((msg) => {
            self._toaster.showSuccess(msg);
        });

    }

    public editOrg(param) {
        let self = this;
        this.share.saveData({ org: param, type: 'EDIT' });
        const modalRef = this.modalService
            .open(AddParentOrganizationComponent).result.then((result) => {
                this.addToParent(result);
            }, (reason) => {
                ;
            });
    }

    public addToParent(event: any) {
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        let parentOrg: any = this.share.getData();
        let mainOrgChilds = parentOrg.mainOrg.org.childOrgs;
        let parOrgData = event.data;
        for (let i in this.childOrgs) {
            if (this.childOrgs[i].id === parOrgData.id) {
                this.childOrgs[i] = parOrgData;
                this.childOrgs[i].childOrgs = mainOrgChilds;
            }
        }
        this.translate.get('orgUpdated').subscribe((msg) => {
            this._toaster.showSuccess(msg);
        });
        this.refresh.emit("");
        //this.router.navigate(['menu/organizationList']);
    }

    public refreshLocal(param){
        this.refresh.emit("");
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/org/childOrgs.ts